// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/e4f609df5a48ea49da85.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"799dbb7b2b3eefff7a5a","216":"25deaccf8a34e9e84f64","217":"2e84640833080cdb6f53"}[chunkId] + ".chunk.js";
};